import {createAsyncThunk} from "@reduxjs/toolkit";
import {iStateMessage} from "@/customTypes/GenericReduxTypes";

import {iGenericResponse} from "@/customTypes/CommonServiceTypes";
import {curryGetThunkName} from "@/projectUtils/ReduxUtil";
import {httpStatusCodes} from "@/customTypes/NetworkTypes";
import { themeService } from "@/services/api/cresivoxServer";

import { REDUCER_NAME,iThemeForm } from './Types';
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

export const addTheme = createAsyncThunk<
  iGenericResponse<any | null> | null,
  iThemeForm,
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("uploadTheme"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types

  async (payload, {rejectWithValue}) => {
    try {
      const response = await themeService.addTheme(payload);
      if (response) {
        const {httpStatusCode, data, message} = response;
        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_CREATED: {
            if (data && data.data) {
              return {
                data: {
                  orders: data.data,
                  message,
                }
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }
          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  },
);


export const getAllThemeList = createAsyncThunk<
  iGenericResponse<any | null> | null,
  void,
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getAllThemeList"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types

  async (payload, {rejectWithValue}) => {
    try {
      const response = await themeService.getAllThemeList();
      if (response) {
        const {httpStatusCode, data, message} = response;
        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && data.data) {
              return {
                data: {
                  data: data.data,
                  message,
                }
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }
          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  },
);


